/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function FlameIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="flame"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M9 17C9.5 15 12 13.5 12 13.5C12 13.5 14.5 15 15 17C15.5 19 14.5 20.5 14 21.5C18 21.5 19.5 17.84 19.5 15.5C19.5 13.16 18.5 12.5 17.5 11C16.5 9.5 16.5 7.5 16.5 7.5L13.5 10.5C13.5 10.5 13.5 7.5 12.5 5.5C11.5 3.5 8.5 2.5 8.5 2.5C8.5 2.5 9 6 8 8C7 10 4.5 11.889 4.5 15.12C4.5 18.352 6 21.5 10 21.5C9.5 20.5 8.5 19 9 17Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
